import { z } from 'zod';

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf'
] as const;

export const ALLOWED_DOCUMENT_TYPES = [
  'passport',
  'national_id',
  'drivers_license'
] as const;

export const fileSchema = z.object({
  name: z.string().min(1),
  size: z.number().max(MAX_FILE_SIZE, 'File size must be less than 10MB'),
  type: z.enum(ALLOWED_FILE_TYPES, {
    description: 'Only JPEG, PNG, and PDF files are accepted'
  })
});

export const documentSchema = z.object({
  type: z.enum(ALLOWED_DOCUMENT_TYPES, {
    description: 'Only passports, national IDs, and driver\'s licenses are accepted'
  }),
  number: z.string().min(1),
  issuingCountry: z.string().min(2).max(2), // ISO country code
  expiryDate: z.date().min(new Date(), 'Document must not be expired')
});

export async function validateFile(file: File): Promise<z.infer<typeof fileSchema>> {
  try {
    return fileSchema.parse({
      name: file.name,
      size: file.size,
      type: file.type
    });
  } catch (error) {
    if (error instanceof z.ZodError) {
      throw new Error(error.errors[0].message);
    }
    throw error;
  }
}